export const PROFILER = 'PROFILER';
export const PAGES = 'PAGES';
